export function TranslateDirective(fdTranslate, translateModalService) {
  'ngInject';

  return {
    link: link
  };

  function link(scope, element, attributes) {
    // Prevent linking when hotkey is not enabled
    if (!fdTranslate.options.hotkey) {
      return;
    }

    // Bind rightclick
    element.bind('contextmenu', (event) => {
      // Enforce a pressed meta key (ctrl or alt)
      if (!event.ctrlKey && !event.altKey) {
        return;
      }
      event.preventDefault();

      const text = element.text();
      const value = element.html();
      const key = attributes.translate;

      translateModalService.open({ text, value, key }).then(result => {
        if (result && result.value) {
          element.html(result.value);
        }
      });
    });
  }
}

export function autofocus($timeout) {
  'ngInject';
  return {
    restrict: 'A',
    link : ($scope, $element) => {
      $timeout(() => $element[0].focus());
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translate/src/translate.directive.js